<template>
  <div>
    <div class="titleBar">
      <div class="title icon-statement">{{ $t('statement') }}</div>
      <div class="filterArea">
        <div class="filter" title="Tải lại" onclick="history.go(0)">
            <span class="icon-refresh"></span>
        </div>
      </div>
    </div>
    <div class="wrapbox">
      <div>
        <div v-if="content === null">
          <div class="preloader">
            <div class="spin">
              <div class="spin-circle"></div>
              <div class="spin-circle"></div>
              <div class="spin-circle"></div>
              <div class="spin-circle"></div>
              <div class="spin-circle"></div>
            </div>
          </div>
	      </div>
        <div v-if="content !== null">
          <table class="accountTable" cellspacing="0" cellpadding="0" style="border-collapse:collapse;">
            <tr class="tableHead">
              <th align="left" scope="col" style="width:10%;">
                <div title="Ngày">Ngày</div>
              </th>
              <th align="right" scope="col" style="width:13%;">
                <div title="Tiền Cược">Tiền Cược</div>
              </th>
              <th align="right" scope="col" style="width:13%;">
                <div title="Thắng / Thua">Thắng / Thua</div>
              </th>
              <th scope="col" style="width:5%;">&nbsp;</th>
            </tr>
              <tr v-for="(row, index) in content" :key="index"
                class="tableRow tableRow-pointer"
                valign="middle"
              >
                <td align="left" style="width:10%;">
                  <div>{{ row.betDate }}</div>
                </td>
                <td align="right" style="width:13%;">
                  <div class="credit">{{ Number(row.amountTotal).toLocaleString() }}</div>
                </td>
                <td align="right" style="width:13%;">
                  <div class="credit">{{ formatAmountWinTotal(row.amountWinTotal) }}</div>
                </td>
                <td align="center" style="width:5%;">
                  <div class="smallBtn icon-next" title="Xem chi tiết" @click="showDetail(row.betDate)"></div>
                </td>
              </tr>
          </table>
	      </div>
        <span class="gmtMessage">
          <p class='gmtMessage'>
            <span>{{ $t('content.pay_attention') }}: </span>{{ $t('content.footer') }}
          </p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {mapActions, mapState} from 'vuex';

export default {
  computed: {
    ...mapState('dailyStatement', ['content']),
  },
  mounted() {
    const { token } = this.$router.currentRoute.query;
    this.getDailyStatement({token});
  },
  methods: {
    ...mapActions('dailyStatement', ['getDailyStatement']),
    showDetail: function(date){
      const { token } = this.$router.currentRoute.query;
      const formatDate = moment(date).format("YYYY/MM/DD");
      const url = `/dailystatementdetail?token=${token}&date=${formatDate}`;
      // window.open(url);
      this.$router.push(url)
    },
    formatAmountWinTotal: function(value){
      if(value === undefined || value === "") return "Chưa xác định";
      return Number(value).toLocaleString()
    }
  }
}
</script>

<style>

</style>
